<template>
    <div class="footer">
      <ScrollTop></ScrollTop>
      <NewsFooter></NewsFooter>
      <MenuFooter></MenuFooter>
      <Copyright></Copyright>
    </div>
</template>
<script>
import ScrollTop from './ScrollTop.vue'
import NewsFooter from './NewsFooter.vue'
import MenuFooter from './MenuFooter.vue'
import Copyright from './Copyright.vue'
export default {
  components: {
    ScrollTop,
    NewsFooter,
    MenuFooter,
    Copyright
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue